import React from "react";

import { whiteBackgroundWhitelistedRoutes } from "@config/app.routing";
import { BODY_WHITE_BG_CLASS } from "@config/consts";

import { useMatchPath } from "@hooks/useMatchPath";

/**
 * This component is responsible for setting white background on body element for whitelisted routes.
 */
const BodyBgController = (): null => {
  const matchPath = useMatchPath();

  const isWhitelistedRoute = whiteBackgroundWhitelistedRoutes.some(matchPath);

  React.useEffect(() => {
    if (!document || !document.body) return;

    document.body.classList.toggle(BODY_WHITE_BG_CLASS, isWhitelistedRoute);

    return () => {
      if (!document || !document.body) return;

      document.body.classList.remove(BODY_WHITE_BG_CLASS);
    };
  }, [isWhitelistedRoute]);

  return null;
};

export { BodyBgController };
